import {useEffect} from 'react';

import {getLegacyNullableStepFromAnalysis} from 'analysis-tool/data/getStepFromAnalysis';
import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getProfilerEventValue, logProfilerTimingEvent} from 'performance/BenchlingProfiler';
import {
  MODAL_SUPPORTED_STEP_CREATED_EVENT,
  MODAL_SUPPORTED_STEP_FINISHED_EVENT,
} from 'performance/processAnalysesEvents';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';
import usePrevious from 'ui-library/hooks/usePrevious';

const COMPLETED_STEP_STATUS_CODES: Array<PipelineStepStatusCode | undefined> = [
  PipelineStepStatusCode.SUCCEEDED,
  PipelineStepStatusCode.FAILED,
];

/**
 * Track the completion of a step that was run via the InputAwareStepConfigModal.
 */
export default function useLogModalSupportedStepProfilerTimings(analysis: PipelineGraphQL): void {
  const stepCreatedEventValue = getProfilerEventValue(MODAL_SUPPORTED_STEP_CREATED_EVENT);
  const stepId = stepCreatedEventValue?.extra?.stepId as string | undefined;
  const modalStep = stepId != null ? getLegacyNullableStepFromAnalysis(analysis, stepId) : null;

  const statusCode = modalStep?.statusCode;
  const previousStatusCode = usePrevious(statusCode);

  useEffect(() => {
    if (
      modalStep != null &&
      COMPLETED_STEP_STATUS_CODES.includes(statusCode) &&
      !COMPLETED_STEP_STATUS_CODES.includes(previousStatusCode)
    ) {
      logProfilerTimingEvent(MODAL_SUPPORTED_STEP_FINISHED_EVENT, {
        stepId: modalStep.id,
        distributionMetadata: {
          steptype: modalStep.definition.stepType.toLowerCase(),
        },
      });
    }
  }, [analysis, modalStep, previousStatusCode, statusCode]);
}
